import { Expose, Type } from "class-transformer";
import {
  IsArray,
  IsNumber,
  IsOptional,
  IsString,
  ValidateNested,
} from "class-validator";

class PromotionalCodeInput {
  @Expose()
  @IsString()
  code: string;

  @Expose()
  @IsString()
  discountType: string;

  @Expose()
  @IsString()
  discount: string;
}

class AddOnInput {
  @Expose()
  @IsString()
  sku: string;

  @Expose()
  @IsString()
  name: string;

  @Expose()
  @IsNumber()
  price: number;
}

class CartInput {
  @Expose()
  @IsString()
  packageName: string;

  @Expose()
  @IsString()
  @IsOptional()
  lotSize?: string;

  @Expose()
  @IsString()
  sku: string;

  @Expose()
  @IsNumber()
  @IsOptional()
  modifiedPrice?: number;

  @Expose()
  @ValidateNested()
  @Type(() => PromotionalCodeInput)
  @IsOptional()
  promotionalCode?: PromotionalCodeInput;

  @Expose()
  @ValidateNested({ each: true })
  @Type(() => AddOnInput)
  @IsArray()
  @IsOptional()
  addOns?: AddOnInput[];
}

export class CustomerLeadAddress {
  @Expose()
  @IsString()
  @IsOptional()
  street?: string;

  @Expose()
  @IsString()
  @IsOptional()
  city?: string;

  @Expose()
  @IsString()
  @IsOptional()
  state?: string;

  @Expose()
  @IsString()
  @IsOptional()
  zip?: string;
}

export class CustomerLeadCartInput {
  @Expose()
  @ValidateNested()
  @Type(() => CartInput)
  cart: CartInput;

  @Expose()
  @IsString()
  @IsOptional()
  userId?: string;

  @Expose()
  @IsString()
  @IsOptional()
  email?: string;

  @Expose()
  @IsString()
  @IsOptional()
  paymentIntentId?: string;

  @Expose()
  @ValidateNested()
  @Type(() => CustomerLeadAddress)
  @IsOptional()
  address?: CustomerLeadAddress;
}
